import React, { RefObject } from 'react';

import { connect } from 'react-redux';
import { FormInstance } from 'antd/lib/form';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { RootState } from '@share/utils';
import { insuranceActions, InsuranceSelection, IReviewBookState, setCard } from '@store/slices';
import { ICardBooking } from '@common-types';
import { CreditCardsList, PaymentMethodBase } from '@components';
import { NULL_VALUE, ROOMS_UNAVAILABLE_ERROR } from '@constants';
import { ILoginState, IMenuState } from '@share/store/slices';

import './style.scss';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  menuStore: IMenuState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  setCard: (card: ICardBooking) => void;
  setSelection: (selection: InsuranceSelection) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps {
  formRef: RefObject<FormInstance>;
  isRequired: boolean;
  display: boolean;
  onChangeCountryState: () => void;
}

interface IState {
  refreshPayment: boolean;
}

class PaymentMethodComponent extends React.Component<IProps, IState> {
  state: IState = { refreshPayment: false };

  handleCardSelect = async (selectedCard: any) => {
    const { setCard, setSelection } = this.props;
    await setCard(selectedCard);
    this.setState({ refreshPayment:  true });
    setSelection(NULL_VALUE);
  }

  render(): React.ReactNode {
    const { isRequired, formRef, display, reviewBookStore, loginStore, menuStore, setCard, onChangeCountryState } = this.props;
    const { refreshPayment } = this.state;
    const { card, errorsField, loadingBooking, error, expiredSession } = reviewBookStore;
    const { account } = loginStore;
    const { items } = menuStore;

    const isRoomUnavaliableError = error === ROOMS_UNAVAILABLE_ERROR;

    return (
      <div>
        <CreditCardsList
          selectedCardId={card?.id}
          onSelectCard={this.handleCardSelect}
          forceHide={isRoomUnavaliableError || expiredSession}
          selectable
          hideIfNoData
          isCheckout
        />

        <PaymentMethodBase
          form={NULL_VALUE}
          formRef={formRef}
          display={display}
          isRequired={isRequired}

          refreshData={refreshPayment}
          onDataRefreshed={() => this.setState({ refreshPayment: false })}
          onChangeCountryState={onChangeCountryState}

          card={card}
          errorsField={errorsField}
          loading={loadingBooking}
          setCard={(card) => setCard(card)}

          displaySave={account?.isPrivateTokenAccountType || account?.isPrivateLoginAccountType}

          disableInsurance={!account?.enableInsurance || items?.isRemoveInsurance} 
          
          residency={false}
        />
      </div>);
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  setCard,
  setSelection: insuranceActions.setSelection,
};

export const PaymentMethod = connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PaymentMethodComponent));
